<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Çeviri Güncelleme">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Güncllenecek çeviri keyi benzersiz
                olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/translations"
          >
            Çeviri Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Çeviri Ekleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Key" label-for="key">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Key"
                  >
                    <b-form-input
                      id="key"
                      v-model="key"
                      placeholder="Key"
                      :state="errors.length > 0 ? false : null"
                      :class="key.length >= chars.key ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="key.length >= chars.key ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ key.length }}</span>
                      /
                      {{ chars.key }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              v-if="translations.length > 0"
              v-for="(translation, index) in translations"
              :key="index"
            >
              <b-col md="12">
                <b-form-group
                  :label="`${translation.code.toUpperCase()} Çeviri`"
                  :label-for="translation.code"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    :name="`${translation.code.toUpperCase()} Çeviri`"
                  >
                    <b-form-textarea
                      :id="translation.code"
                      v-model="translation.text"
                      :placeholder="`${translation.code.toUpperCase()} Çeviri`"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        translation.text.length >= chars.translation ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        translation.text.length >= chars.translation ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ translation.text.length }}</span>
                      /
                      {{ chars.translation }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false)"
                  >
                    <b-spinner v-if="spinner === true && isDraft === false" small />
                    {{
                      spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla"
                    }}
                  </b-button>
                </div>
                <div>
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="postConfirmText(true)"
                  >
                    <b-spinner v-if="spinner == true && isDraft == true" small />
                    {{
                      spinner == true && isDraft == true
                        ? "Taslağa Kaydediliyor"
                        : "Taslağa Kaydet"
                    }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: this.$route.params.idParam,
      key: "",
      translations: [],
      translationsData: [],
      isDraft: false,
      spinner: false,
      languages: [],
      chars: {
        key: 255,
        translation: 1500,
      },
    };
  },
  watch: {},
  methods: {
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
          this.languages.forEach((language) => {
            this.translations.push({
              code: language.code,
              text: "",
            });
          });
          this.getTranslationById();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTranslationById() {
      endpoints
        .getTranslationById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.translationData = data.response;
          this.key = this.translationData.key;
          Object.entries( this.translationData.translation).forEach(([key, value]) => {
            this.translations.forEach(element => {
                if(element.code == key){
                    element.text = value;
                }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Çeviriyi güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("id", this.id);
          formData.append("key", this.key);
          formData.append("translation", JSON.stringify(this.translations));
          endpoints
            .putTranslation(formData, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Çeviri güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/translations`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Çeviri benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getLanguages();
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
